var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.projects.length > 0
    ? _c("div", { staticClass: "m-b-5" }, [
        _c("div", { staticClass: "featured-project-banner" }, [
          _c("a", { attrs: { href: _vm.project.url } }, [
            _c("div", {
              staticClass: "wa-responsive-image--h450",
              style:
                "background-image: url(" +
                "https://www.world-architects.com" +
                _vm.project.featured_photo.image_versions.w1200 +
                ")",
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "super-module" }, [
            _c("h5", { staticClass: "no-margin no-border font-sans bold" }, [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.project.company.company) + "\n\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "no-margin no-border m-b-1" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.project.name) + "\n\t\t\t"),
            ]),
            _vm._v(" "),
            _vm.project.featured_photo.copyright_holder
              ? _c(
                  "p",
                  { staticClass: "no-margin super-module-image-copyright" },
                  [
                    _vm._v(
                      "\n\t\t\t\t© " +
                        _vm._s(_vm.project.featured_photo.copyright_holder) +
                        "\n\t\t\t"
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }